import { useMemo } from 'react'

import { Table, Text } from '@domain-group/suit-theme'
import type { Column } from '@domain-group/suit-theme/dist/components/Table'

import useSelector from '@hooks/useSelector'

import type { EntitiesState } from '@redux/entities'

import { OrderBundleItemModel } from '@models/orderBundleItem'

import useCurrentUser from '@hooks/useCurrentUser'

import OrderBundleProductActions from './OrderBundleProductActions'

interface OrderBundleProductsTableProps {
  filteredOrderBundleItems: OrderBundleItemModel[],
}

const buildColumns = (
  currentProviderId: number,
  isAdmin: boolean,
  providers: EntitiesState['providers'],
  providerPriceLists: EntitiesState['providerPriceLists'],
  publications: EntitiesState['publications'],
): Column[] => [
  {
    title: 'Provider',
    // @ts-expect-error TS2322
    dataKey: 'provider_id',
    // @ts-expect-error TS2322
    render: (providerId: number) => {
      const title = currentProviderId === providerId ? providers[providerId]?.title || 'N/A' : 'Other Provider'

      return (
        <Text variant="ellipsis" minWidth="100px" style={{ whiteSpace: 'nowrap' }}>
          {currentProviderId ? title : providers[providerId]?.title || 'N/A'}
        </Text>
      )
    },
  },
  {
    title: 'Price List',
    // @ts-expect-error TS2322
    dataKey: 'provider_price_list_id',
    // @ts-expect-error TS2322
    render: (providerPriceListId: number) => (
      <Text variant="ellipsis" minWidth="100px" style={{ whiteSpace: 'nowrap' }}>
        {providerPriceLists[providerPriceListId]?.title || 'N/A'}
      </Text>
    ),
  },
  {
    title: 'Publication',
    // @ts-expect-error TS2322
    dataKey: 'publication_id',
    // @ts-expect-error TS2322
    render: (publicationId: number) => (
      <Text variant="ellipsis" minWidth="100px" maxWidth="200px">
        {publications[publicationId]?.title || 'N/A'}
      </Text>
    ),
  },
  {
    title: 'Item',
    // @ts-expect-error TS2322
    dataKey: 'title',
    // @ts-expect-error TS2322
    render: (title: string) => (
      <Text variant="ellipsis" minWidth="100px" maxWidth="250px">
        {title || 'N/A'}
      </Text>
    ),
  },
  {
    title: 'Product Name',
    // @ts-expect-error TS2322
    dataKey: 'product_name',
    // @ts-expect-error TS2322
    render: (productName: string) => (
      <Text variant="ellipsis" minWidth="100px" maxWidth="200px">
        {productName || 'N/A'}
      </Text>
    ),
  },
  {
    title: 'Product Code',
    // @ts-expect-error TS2322
    dataKey: 'product_code',
    // @ts-expect-error TS2322
    render: (productCode: number) => productCode || 'N/A',
  },
  {
    title: 'Price',
    // @ts-expect-error TS2322
    dataKey: 'price_override',
    cellProps: {
      width: 100,
    },
    // @ts-expect-error TS2322
    render: (priceOverride: string) => priceOverride || 'N/A',
  },
  {
    title: 'Sort',
    // @ts-expect-error TS2322
    dataKey: 'sort',
    cellProps: {
      width: 100,
    },
    // @ts-expect-error TS2322
    render: (sort: number) => sort || 'Default',
  },
  {
    title: 'Actions',
    dataKey: 'id',
    cellProps: {
      textAlign: 'end',
    },
    // @ts-expect-error TS2322
    render: (id: number) => (
      <OrderBundleProductActions
        currentProviderId={currentProviderId}
        isAdmin={isAdmin}
        orderBundleItem={{ id }}
      />
    ),
  },
]

const OrderBundleProductsTable = (props: OrderBundleProductsTableProps) => {
  const { filteredOrderBundleItems } = props

  const { providerPriceLists, providers, publications } = useSelector(reduxState => reduxState.entities)

  const { isAdmin, provider, isProviderUser } = useCurrentUser()

  const currentProviderId = isProviderUser ? provider?.id : null

  const memoColumns = useMemo(
    // @ts-expect-error TS2345
    (): Column[] => buildColumns(currentProviderId, isAdmin, providers, providerPriceLists, publications),
    [filteredOrderBundleItems.length],
  )

  return (
    <Table
      boxProps={{ border: 'none', maxHeight: 300, overflowY: 'auto' }}
      columns={memoColumns}
      // @ts-expect-error TS2322
      data={filteredOrderBundleItems}
      stickyHeader
    />
  )
}

export default OrderBundleProductsTable
